/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CartItem } from './CartItem';
import {
    CartItemFromJSON,
    CartItemFromJSONTyped,
    CartItemToJSON,
} from './CartItem';
import type { Unit } from './Unit';
import {
    UnitFromJSON,
    UnitFromJSONTyped,
    UnitToJSON,
} from './Unit';

/**
 * 
 * @export
 * @interface PurchaseHistoryDetail
 */
export interface PurchaseHistoryDetail {
    /**
     * 
     * @type {string}
     * @memberof PurchaseHistoryDetail
     */
    purchaseId?: string;
    /**
     * 
     * @type {Date}
     * @memberof PurchaseHistoryDetail
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof PurchaseHistoryDetail
     */
    productId?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseHistoryDetail
     */
    productCanonicalId?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseHistoryDetail
     */
    quantity?: number;
    /**
     * indicates whether this purchase was cancelled
     * @type {boolean}
     * @memberof PurchaseHistoryDetail
     */
    cancelled?: boolean;
    /**
     * 
     * @type {Array<CartItem>}
     * @memberof PurchaseHistoryDetail
     */
    additionals?: Array<CartItem>;
    /**
     * 
     * @type {Date}
     * @memberof PurchaseHistoryDetail
     */
    validFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PurchaseHistoryDetail
     */
    validTo?: Date;
    /**
     * 
     * @type {Unit}
     * @memberof PurchaseHistoryDetail
     */
    unit?: Unit;
}

/**
 * Check if a given object implements the PurchaseHistoryDetail interface.
 */
export function instanceOfPurchaseHistoryDetail(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PurchaseHistoryDetailFromJSON(json: any): PurchaseHistoryDetail {
    return PurchaseHistoryDetailFromJSONTyped(json, false);
}

export function PurchaseHistoryDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseHistoryDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'purchaseId': !exists(json, 'purchaseId') ? undefined : json['purchaseId'],
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'productId': !exists(json, 'productId') ? undefined : json['productId'],
        'productCanonicalId': !exists(json, 'productCanonicalId') ? undefined : json['productCanonicalId'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'cancelled': !exists(json, 'cancelled') ? undefined : json['cancelled'],
        'additionals': !exists(json, 'additionals') ? undefined : ((json['additionals'] as Array<any>).map(CartItemFromJSON)),
        'validFrom': !exists(json, 'validFrom') ? undefined : (new Date(json['validFrom'])),
        'validTo': !exists(json, 'validTo') ? undefined : (new Date(json['validTo'])),
        'unit': !exists(json, 'unit') ? undefined : UnitFromJSON(json['unit']),
    };
}

export function PurchaseHistoryDetailToJSON(value?: PurchaseHistoryDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'purchaseId': value.purchaseId,
        'date': value.date === undefined ? undefined : (value.date.toISOString()),
        'productId': value.productId,
        'productCanonicalId': value.productCanonicalId,
        'quantity': value.quantity,
        'cancelled': value.cancelled,
        'additionals': value.additionals === undefined ? undefined : ((value.additionals as Array<any>).map(CartItemToJSON)),
        'validFrom': value.validFrom === undefined ? undefined : (value.validFrom.toISOString()),
        'validTo': value.validTo === undefined ? undefined : (value.validTo.toISOString()),
        'unit': UnitToJSON(value.unit),
    };
}

